import type { Novidade } from './tipos';

/**
 * Fase 2 (W37): o comparativo "antes e depois" das telas virou a aba Histórico telas do Painel admin. As imagens da
 * novidade são de um catálogo de DEMONSTRAÇÃO com dados fictícios do banco local (`CAPTURAR=1` na prova
 * `scripts/provas/w37-historico.ts`): as capturas reais do "antes" podem ter dado real e nunca vão para a pasta pública.
 */
export const novidadeHistoricoTelas: Novidade = {
  id: '2026-10-05-historico-telas',
  publicada_em: '2026-10-05',
  tipo: 'novo',
  modulo: 'admin',
  permissao: 'admin.ver',
  rota: '/admin/admin/historico-telas',
  imagens: ['/novidades/2026-10-05-historico-telas/pagina.webp', null, '/novidades/2026-10-05-historico-telas/ampliar.webp'],
  textos: {
    pt: {
      titulo: 'Histórico telas: o antes e o depois no próprio sistema',
      resumo: 'O comparativo das telas, antes e depois da fase 2, agora fica no Painel admin, para o administrador da plataforma.',
      passos: [
        'Abra Admin > Painel admin > Histórico telas.',
        'Cada tela mostra o antes e o depois lado a lado; no celular, um embaixo do outro.',
        'Clique numa imagem para ampliar. No modo discreto as imagens ficam ocultas.',
      ],
    },
    en: {
      titulo: 'Screen history: before and after inside the system',
      resumo: 'The screen comparison, before and after phase 2, now lives in the Admin panel, for the platform administrator.',
      passos: [
        'Open Admin > Admin panel > Screen history.',
        'Each screen shows before and after side by side; on mobile, one below the other.',
        'Click an image to enlarge it. In discreet mode the images are hidden.',
      ],
    },
    es: {
      titulo: 'Historial de pantallas: el antes y el después en el sistema',
      resumo: 'La comparación de pantallas, antes y después de la fase 2, ahora está en el Panel admin, para el administrador de la plataforma.',
      passos: [
        'Abre Admin > Panel admin > Historial de pantallas.',
        'Cada pantalla muestra el antes y el después lado a lado; en el móvil, uno debajo del otro.',
        'Haz clic en una imagen para ampliarla. En el modo discreto las imágenes quedan ocultas.',
      ],
    },
  },
  treinamento: { curso: 'novidades' },
};

/** Fase 2 (W39): o aviso "Nova versão disponível" para quem está com a tela aberta durante uma publicação. */
export const novidadeNovaVersao: Novidade = {
  id: '2026-10-05-nova-versao',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: null,
  permissao: null,
  imagens: ['/novidades/2026-10-05-nova-versao/aviso.webp', null, null],
  textos: {
    pt: {
      titulo: 'Aviso de nova versão disponível',
      resumo: 'Quando o sistema é atualizado com a tela aberta, aparece o aviso "Nova versão disponível" com o botão Atualizar.',
      passos: [
        'O aviso aparece no canto da tela e não some sozinho, sem interromper o que você está fazendo.',
        'Salve o que estiver editando e clique em Atualizar para carregar a versão nova.',
        'Se uma tela não abrir por causa da atualização, o mesmo aviso aparece no lugar do erro.',
      ],
    },
    en: {
      titulo: 'New version available notice',
      resumo: 'When the system is updated while your screen is open, a "New version available" notice shows up with a Refresh button.',
      passos: [
        'The notice shows up in the corner of the screen and does not disappear on its own, without interrupting your work.',
        'Save what you are editing and click Refresh to load the new version.',
        'If a screen does not open because of the update, the same notice shows up instead of the error.',
      ],
    },
    es: {
      titulo: 'Aviso de nueva versión disponible',
      resumo: 'Cuando el sistema se actualiza con la pantalla abierta, aparece el aviso "Nueva versión disponible" con el botón Actualizar.',
      passos: [
        'El aviso aparece en la esquina de la pantalla y no desaparece solo, sin interrumpir lo que estás haciendo.',
        'Guarda lo que estés editando y haz clic en Actualizar para cargar la versión nueva.',
        'Si una pantalla no abre por la actualización, el mismo aviso aparece en lugar del error.',
      ],
    },
  },
  treinamento: { curso: 'novidades' },
};
